module.exports = __webpack_public_path__ + "static/media/ic-one-more-benefit.46835de7.svg";